type ErrorLike = Error & {
  digest?: string;
};

type AppLogErrorDetails = {
  error_name: string;
  error_message: string;
  error_stack?: string;
  error_digest: string;
};

function hashString(value: string) {
  let hash = 0;

  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }

  return Math.abs(hash).toString(36);
}

export function createAppLogDigest(parts: unknown[]) {
  return hashString(
    parts
      .map((part) => {
        if (part === undefined) return "undefined";
        if (part === null) return "null";
        return String(part);
      })
      .join(":"),
  );
}

export function getAppLogErrorDetails(
  error: unknown,
  fallback: {
    name: string;
    message: string;
    digestParts: unknown[];
  },
): AppLogErrorDetails {
  if (error instanceof Error) {
    const errorLike = error as ErrorLike;
    const errorName = error.name || fallback.name;
    const errorMessage = error.message || fallback.message;

    return {
      error_name: errorName,
      error_message: errorMessage,
      error_stack: error.stack || new Error(errorMessage).stack,
      error_digest:
        errorLike.digest ||
        createAppLogDigest([errorName, errorMessage, ...fallback.digestParts]),
    };
  }

  const message =
    error === undefined || error === null ? fallback.message : String(error);

  return {
    error_name: fallback.name,
    error_message: message,
    error_stack: new Error(message).stack,
    error_digest: createAppLogDigest([
      fallback.name,
      message,
      ...fallback.digestParts,
    ]),
  };
}
